module.exports = __webpack_public_path__ + "static/img/1-2.38675d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/1-2.png
// module id = 3JNS
// module chunks = 0